import { BUCKETS } from "@/constants";
import { supabase } from "@/services/supabase/createClient";

export const readFileFromStorage = async (promptbookId: string, fileId: string) => {
  const filePath = `${promptbookId}/files/${fileId}`;

  const { data, error } = await supabase.storage.from(BUCKETS.promptbooks).download(filePath);

  if (error) {
    throw error;
  }

  const fileText = await data.text();

  // NOTE: ideally we would store additional metadata and create
  // a more "correct" file with the proper file name and type
  // e.g. CSV
  return new File([fileText], fileId, { type: data.type });
};
